import script from "./DashboardCertificates.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardCertificates.vue?vue&type=script&setup=true&lang=js"

import "./DashboardCertificates.vue?vue&type=style&index=0&id=774a704e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-774a704e"]])

export default __exports__